import { React, useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"; // For the left arrow icon

const WhitelistRequest = ({ onBackClick, merchantID }) => {
  const [userName, setuserName] = useState("");
  const [userNameError, setuserNameError] = useState(false);
  const [merchantIDError, setmerchantIDError] = useState(false);

  const handleRequestWhitelist = () => {
    let isValid = true;

    // Validate merchantID
    if (!merchantID) {
      setmerchantIDError(true);
      isValid = false;
    } else {
      setmerchantIDError(false);
    }

    // Validate userName
    if (!userName) {
      setuserNameError(true);
      isValid = false;
    } else {
      setuserNameError(false);
    }

    // Stop execution if any field is invalid
    if (!isValid) return;

    // Pre-fill the email with user data
    const emailBody = `
      BimTech ID: ${userName}
      Kalp Wallet ID: ${merchantID}
    `;
    // Create a mailto link with subject and body
    const mailToLink = `mailto:request.cbdc@bimtech.ac.in?subject=Request for Whitelist&body=${encodeURIComponent(
      emailBody
    )}`;

    // Open default email client (Google Mail will be prompted if set as the default)
    window.location.href = mailToLink;
  };

  return (
    <Box
      sx={{
        padding: "40px",
        maxWidth: "500px",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      {/* Back Button and Title on the same line */}
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: "30px" }}>
        <Button
          variant="text"
          onClick={onBackClick}
          sx={{
            color: "#6a00f4",
            textTransform: "none",
            minWidth: "fit-content",
            marginRight: "10px", // Adjust spacing between arrow and title
            padding: 0,
          }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: "20px" }} />
        </Button>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
          }}
        >
          Whitelisting Request
        </Typography>
      </Box>

      {/* Input Fields */}
      <Box component="form">
        <TextField
          placeholder="Enter User's Address" // Removed label, replaced with placeholder
          variant="outlined"
          fullWidth
          value={merchantID}
          error={merchantIDError}
          helperText={merchantIDError ? "User address is required" : ""}
          sx={{
            marginBottom: "20px",
            backgroundColor: "transparent",
            borderRadius: "15px",
          }}
          InputProps={{
            readOnly: true,
            sx: {
              borderRadius: "12px",
              height: "50px",
              "& .MuiFormHelperText-root": {
                backgroundColor: "transparent", // Set the error message background to transparent
                marginLeft: 0, // Optionally remove the margin
              },
            },
          }}
        />
        <TextField
          placeholder="Enter your BimTech ID" // Removed label, replaced with placeholder
          variant="outlined"
          fullWidth
          onChange={(e) => setuserName(e.target.value)}
          value={userName}
          error={userNameError}
          helperText={userNameError ? "BimTech ID is required" : ""}
          sx={{
            marginBottom: "30px",
            backgroundColor: "transparent",
            borderRadius: "15px",
          }}
          InputProps={{
            sx: { borderRadius: "12px", height: "50px" },
          }}
        />

        {/* Send Request Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleRequestWhitelist}
          sx={{
            backgroundColor: "#6200ea",
            color: "#fff",
            padding: "15px 0",
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#4b00c7",
            },
          }}
        >
          Send Request
        </Button>
      </Box>
    </Box>
  );
};

export default WhitelistRequest;
